<button 
	type="button"
	class="InfoTooltip InfoTooltip--{{ iconColor() }}" 
	[matTooltip]="tooltipText()" 
	[matTooltipPosition]="tooltipPosition()"
	aria-label="Información adicional"
>
	<mat-icon>info_outline</mat-icon>
</button>

